import { Grid } from '@mui/material'
import React, { createContext, useState } from 'react'
import AddEditForm from './AddEditForm'
import { PermissionGuard } from '../../../../components/PermissionGuard'
import { UrbanTypeServices } from './UrbanTypeServices'
import UrbanTypeList from './UrbanTypeList'

const UrbanTypeDataContext = createContext();

const UrbanType = () => {
    const urbanTypeInitialData = {
        typeTitle: '',
        numberOfExpertOrderFree: 0,
        typeCities: [],
        typeCitiesPinCodes: [],
        typeDescription: '',
        status:false,
    }
    const [urbanTypeData, setUrbanTypeData] = useState(urbanTypeInitialData);

    const [paginationModel,setPaginationModel] = useState({
        page: 0,
        pageSize: 20,
        filters: {
            // searchKey: "",
            sortBy:'updatedAt',
            sortType:'desc',
            filterOptions: []
        }
    })
    const [urbanTypeList, setUrbanTypeList] = useState([]);
    const [totalRowCount,setTotalRowCount] = useState(0);
    const [loadingList,setLoadingList] = useState(false)

    const fetchUrbanTypeList = async() => {
        setLoadingList(true);
        try{
            const response = await UrbanTypeServices.fetchUrbanTypeList(paginationModel);
            console.log('urban type list fetching response :',response);

            if(response.success == '1'){
                setUrbanTypeList(response.data.list)
                setTotalRowCount(response.data.totalItems)
            }else if (response.success == '0'){
                console.log("error :",response?.message)
            }
        }catch (error){
            console.log("error:",error)
        }finally{
            setLoadingList(false)
        }
        
    }

    const [selectedUrbanTypeData, setSelectedUrbanTypeData] = useState(null);
  return (
    <UrbanTypeDataContext.Provider value={{urbanTypeInitialData,urbanTypeData,setUrbanTypeData,fetchUrbanTypeList,urbanTypeList,paginationModel,setPaginationModel,totalRowCount,loadingList,selectedUrbanTypeData, setSelectedUrbanTypeData}}>
        <Grid container spacing={1}>            
            <Grid item xs={12} lg={4}>
                <AddEditForm/>
            </Grid>
            {/* <PermissionGuard feature="gst" permission="canView"> */}
                <Grid item xs={12} lg={8}>
                    <UrbanTypeList/>
                </Grid>
            {/* </PermissionGuard> */}
        </Grid>
    </UrbanTypeDataContext.Provider>
  )
}

export default UrbanType
export {UrbanTypeDataContext};
